import React from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';

export default function ConfirmDeleteModal({
    isOpen,
    onConfirm,
    onCancel,
    title = 'Delete Note',
    message = 'Are you sure you want to delete this note? This action cannot be undone.',
    confirmText = 'Delete',
    cancelText = 'Cancel'
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center dark:bg-slate-900/80 bg-slate-500/50 backdrop-blur-sm px-4">
            <div className="dark:bg-slate-900 bg-white border dark:border-slate-800 border-slate-200 rounded-2xl max-w-sm w-full shadow-2xl">
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b dark:border-slate-800 border-slate-200">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl dark:bg-red-500/20 bg-red-100 border dark:border-red-400/30 border-red-200 flex items-center justify-center">
                            <AlertTriangle className="w-5 h-5 dark:text-red-400 text-red-600" />
                        </div>
                        <h3 className="text-lg font-bold dark:text-white text-slate-900">{title}</h3>
                    </div>
                    <button
                        onClick={onCancel}
                        className="text-slate-400 hover:text-slate-900 dark:hover:text-white p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-5">
                    <p className="dark:text-slate-400 text-slate-600 text-sm leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Footer */}
                <div className="flex gap-3 p-5 border-t dark:border-slate-800 border-slate-200">
                    <button
                        onClick={onCancel}
                        className="flex-1 px-4 py-2.5 rounded-lg border dark:border-slate-700 border-slate-200 dark:text-slate-300 text-slate-700 font-medium hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 px-4 py-2.5 rounded-lg bg-red-600 text-white font-semibold hover:bg-red-500 transition-colors flex items-center justify-center gap-2"
                    >
                        <Trash2 className="w-4 h-4" />
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
